import { createTheme } from "@mui-wrapper";
import { flatUiThemeOptions } from "@flat-ui";

/**
 * The app's theme: the flat-ui theme plus only the layout the app itself needs. Colours,
 * typography and component styling all come from flat-ui, so nothing here restyles it.
 */
export const hbTheme = createTheme(flatUiThemeOptions, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- naming on html class
        "#root": {
          display: "flex",
          flexDirection: "column",
        },

        // eslint-disable-next-line @typescript-eslint/naming-convention -- naming on html class and tag
        "body, #root": {
          height: "100vh",
        },

        main: {
          height: "100%",
        },
      },
    },
  },
});
